
import { AfterViewChecked, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { RegistrationService } from '@shared/services/registration.service';
import { REGISTRATION_STEP_ID } from '@shared/services/steps.service';
import packageObject from 'package';
import { APP_CONFIG } from './app-config.module';
import { DTRUM_ACTION_NAME, DynatraceHelperService } from './shared/services/dynatraceHelper.service';

@Component({
    selector: 'soldo-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.scss']
})

export class AppComponent implements OnInit, AfterViewChecked {
    appVersion: string;
    showVersion: boolean = true;
    environment: string;
    startOverButtonEnabled: boolean = false;
    isStaticRoute: boolean;

    constructor(
        private readonly router: Router,
        private readonly registrationService: RegistrationService,
        private readonly elementRef: ElementRef,
        private readonly dynatrace: DynatraceHelperService
    ) {
        this.appVersion = packageObject["version"];
        this.environment = Inject(APP_CONFIG).env;
        this.showVersion = this.environment !== "prod";
        const startingHash = window.location.hash;
        const staticRouteRegexp = /^#\/static\/.+/;
        this.isStaticRoute = staticRouteRegexp.test(startingHash);
    }

    ngOnInit() {
        // scroll top
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        this.startOverButtonEnabled = this.registrationService.isStepComplete(REGISTRATION_STEP_ID.TERMS);
        this.registrationService.getStepChangeObservable().subscribe(step => {
            if (step.id === REGISTRATION_STEP_ID.LAST   ) {
                this.startOverButtonEnabled = true;
            }
        });
    }

    ngAfterViewChecked(): void {
        const select = this.elementRef.nativeElement.querySelectorAll("input:not([autocomplete=nope])");
        select.forEach(element => {
            element.autocomplete = "nope"; // fake value to hack chrome behaviour
        });
    }

    backToCompanies() {
        const backToAppListActionId = this.dynatrace.enterAction(DTRUM_ACTION_NAME.BACK_TO_APP_LIST);

        this.startOverButtonEnabled = false;
        this.router.navigate([this.registrationService.backToCompanies()]).then(() => {
            this.dynatrace.leaveAction(backToAppListActionId);
        });
    }

}
